export interface KeyValueFilter {
  key: string
  value: string
}

export enum ValueFilter {
  SEATED = 'SEATED',
  UNSEATED = 'UNSEATED',
  REMOTE = 'REMOTE',
  NO_DESK_NEEDED = 'NO_DESK_NEEDED',
  MANUAL = 'MANUAL',
}
